import styled from "@mui/styled-engine-sc";
import { palette } from "../../../themes/color-palette";

export const StyledProductIndispensable = styled("div")`
  ${({ theme }) => `
    .product-indispensable {

    background: #EFF3F6;
    padding: 12px 20px;
    border-radius: 8px;
    margin-bottom: 24px;

    &.cart-modal{
       background: none;
    }

      ${theme.breakpoints.down("sm")} {
        padding-right: 12px;
      }

      .keen-slider:not([data-keen-slider-disabled]) .keen-slider__slide {
        overflow: visible;
      }

      .product-card {
        .product-card-image {

          //max-height: 265px;

          border-radius: 8px 8px 0 0;

        }
        .product-card-content {
          border: none;
        }
        .product-card-pack {
          display: block;
          background: ${palette.blue.background};
          color: ${palette.white.main};
          border-radius: 0 0 8px 8px;
          text-align: left;
          font-weight: 400;
          color: ${palette.beige.light};
          height: 40px;

          .MuiFormControlLabel-root {
            font-weight: 400;
            color: ${palette.beige.light};
          }

          .MuiCheckbox-root {
            color: ${palette.beige.light};
            padding: 0;
            margin-right: ${theme.spacing(2)};
          }
        }
      }
      .product-indispensable-plus {
        position: absolute;
        top: 110px;
        left: -${theme.spacing(8)};
        width: 44px;
        height: 44px;
        background: #FFFFFF;
        box-shadow: 0px 2px 6px rgba(37, 36, 39, 0.25);
        border-radius: 23px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 89;
        color: ${palette.blue.dark};

        ${theme.breakpoints.down("md")} {
          left: -${theme.spacing(7.5)};;
        }
      }

      .product-indispensable-sup {
        font-size: 16px;
      }
      .product-indispensable-button {


        ${theme.breakpoints.down("sm")} {

        }

        button {
          padding: 10px;
        }

        svg path {
          fill: ${palette.blue.dark};
        }
      }
    }
  `}
`;
